import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.'
}, {
  q: 'What grade levels is this designed for?',
  a: 'Every lesson in Food Science Teacher Ready™ is built specifically for Grades 9–12. The content, language, activities, and assessments are all calibrated for high school students.'
}, {
  q: 'Does this work for Food Safety courses specifically?',
  a: 'Yes. Volume 2 is dedicated entirely to Food Safety and Sanitation — 24 complete lessons covering every major food safety concept for Grades 9–12. The Lab Safety Toolkit and Case Study Bank reinforce safety content throughout the entire course.'
}, {
  q: 'Can I edit the material?',
  a: 'The library is delivered in a ready-to-use digital format. It is not provided as editable source files.'
}, {
  q: 'What currency will I pay in?',
  a: 'You pay in your local currency. The amount adjusts automatically based on the country you are purchasing from.'
}, {
  q: 'What if it is not useful for me?',
  a: 'Use it for a full week. If it does not work for your classroom, you get a complete refund. No questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-81" data-mp="11vxojka5xqt4">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="16oh42mseuw0k">
        <div className="text-center mb-16" data-id="element-83" data-mp="16pihgxwwfulg"><h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-84" data-mp="rz2txch0gak4">❓ Frequently Asked Questions</h2></div>
        <div className="space-y-4" data-id="element-85" data-mp="wxw7f4was1ka">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-86" data-mp="ww1htda2zl9v" data-mpi={index}>
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-87" data-mp="j0qucky622fj">
                <span className="font-bold text-lg text-white pr-8" data-id="element-88" data-mp="2kv53v8ijvvf6">{faq.q}</span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-89" data-mp="2fxvgdyeq1ttz" />
              </button>
              <AnimatePresence data-id="element-90" data-mp="38lhh8ywkekd5">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-91" data-mp="38kzedjfed7w9"><div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-92" data-mp="2yn1sh2l0fn6t">{faq.a}</div></motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}